import React, { useMemo } from "react";
import {
  PROFILE_FAV_FOOTBALL_TEAM_OPTIONS,
  footballLogoUsesWhiteTile,
  footballTeamLogoUrl,
  type ProfileFavFootballSlug,
} from "./profileFavFootballTeams";

type Props = {
  selected: readonly string[];
  onToggle: (slug: ProfileFavFootballSlug) => void;
};

export function ProfileFavouriteFootballGrid({ selected, onToggle }: Props) {
  const selectedSet = useMemo(() => new Set(selected), [selected]);

  return (
    <div className="w-full min-w-0">
      <p className="mb-3 text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none] sm:mb-3.5">
        Favourite Football teams
      </p>
      <div className="grid grid-cols-5 justify-items-center gap-2 sm:gap-2.5">
        {PROFILE_FAV_FOOTBALL_TEAM_OPTIONS.map(({ slug, label }) => {
          const isSelected = selectedSet.has(slug);
          return (
            <button
              key={slug}
              type="button"
              onClick={() => onToggle(slug)}
              aria-pressed={isSelected}
              aria-label={label}
              className={`flex h-[70px] w-[70px] shrink-0 flex-col items-stretch justify-between gap-0 overflow-hidden rounded-none border-[3px] transition-colors ${
                isSelected
                  ? "border-[#D2FF00] bg-[#8255BE]"
                  : "border-transparent bg-white/10 hover:bg-white/[0.14]"
              }`}
            >
              <span className="flex min-h-0 flex-1 flex-col items-center justify-center px-1 py-1.5">
                {footballLogoUsesWhiteTile(slug) ? (
                  <span className="inline-flex max-h-full max-w-full items-center justify-center rounded-none bg-white p-0.5">
                    <img
                      src={footballTeamLogoUrl(slug)}
                      alt=""
                      className="max-h-full max-w-full object-contain"
                      loading="lazy"
                      decoding="async"
                    />
                  </span>
                ) : (
                  <img
                    src={footballTeamLogoUrl(slug)}
                    alt=""
                    className="max-h-full max-w-full object-contain"
                    loading="lazy"
                    decoding="async"
                  />
                )}
              </span>
              <span
                className={`shrink-0 px-0.5 pb-1 text-center font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none] line-clamp-2 ${
                  isSelected ? "text-[#D2FF00]" : "text-white"
                }`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
